import { render, staticRenderFns } from "./CheckDepositForm.vue?vue&type=template&id=56baeb90&"
import script from "./CheckDepositForm.vue?vue&type=script&lang=js&"
export * from "./CheckDepositForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports